import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Link } from "react-router-dom";
import { TeamMember } from "./types";

interface TeamMembersListProps {
  members: TeamMember[];
}

export const TeamMembersList = ({ members }: TeamMembersListProps) => {
  return (
    <div className="space-y-4">
      {members.length === 0 ? (
        <p className="text-gray-400">No team members yet</p>
      ) : (
        members.map((member) => (
          <div key={member.user_id} className="flex items-center gap-4 text-gray-300">
            <Avatar>
              <AvatarImage src={member.profile?.avatar_url || undefined} />
              <AvatarFallback>{member.profile?.username?.[0] || member.profile?.full_name?.[0] || '?'}</AvatarFallback>
            </Avatar>
            <div className="flex flex-col">
              <Link 
                to={`/profile/${member.user_id}`}
                className="text-flux-cyan hover:underline"
              >
                {member.profile?.full_name || member.profile?.username || "Anonymous"}
              </Link>
              <span className="text-sm text-gray-400">{member.role?.title || "Team Member"}</span>
            </div>
          </div>
        ))
      )}
    </div>
  );
};